
import { defineComponent, ref, computed } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { hideModal } from "@/core/helpers/dom";
import { useStore } from "vuex";
import { createNewSite } from "@/core/services/consensu/sites";
import Swal from "sweetalert2/dist/sweetalert2.js";
import * as Yup from "yup";

interface INewSite {
  name: string;
  title: string;
  website: string;
}

export default defineComponent({
  name: "new-site-modal",

  components: {
    ErrorMessage,
    Field,
    Form,
  },
  methods: {
    reset() {
      this.newSite = {
        name: "",
        title: "",
        website: "",
      };
    },
  },

  setup() {
    const store = useStore();

    const submitButtonRef = ref<null | HTMLButtonElement>(null);
    const newSiteModalRef = ref<null | HTMLElement>(null);

    const URL =
      /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/gm;

    const newSite = ref<INewSite>({} as INewSite);

    const owner = computed(() => {
      return store.getters.currentUser._id;
    });

    const validationSchema = Yup.object().shape({
      name: Yup.string().required("Nome é um campo obrigatório"),
      title: Yup.string().required("Título ou Slogan é um campo obrigatório"),
      website: Yup.string()
        .matches(URL, "Digite uma url válida! ex: https://consensu.io")
        .required("Site é um campo obrigatório"),
    });

    const submit = async (values, { resetForm }) => {
      if (!submitButtonRef.value) {
        return;
      }

      let params = {
        owner: owner.value,
        ...newSite.value,
      };

      submitButtonRef.value.disabled = true;
      submitButtonRef.value.setAttribute("data-kt-indicator", "on");

      await createNewSite(params)
        .then(() => {
          if (submitButtonRef.value) {
            submitButtonRef.value.disabled = false;

            submitButtonRef.value?.removeAttribute("data-kt-indicator");
          }

          Swal.fire({
            text: "Um novo site foi adicionado com sucesso!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          }).then(() => {
            resetForm();

            hideModal(newSiteModalRef.value);
          });
        })
        .catch(() => {
          Swal.fire({
            text: "Tivemos um problema ao adicionar o site, tente novamente!",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Encerrar",
            customClass: {
              confirmButton: "btn btn-danger",
            },
          }).then(() => {
            hideModal(newSiteModalRef.value);
          });
        });
    };

    return {
      newSite,
      owner,
      validationSchema,
      submit,
      submitButtonRef,
      newSiteModalRef,
    };
  },
});
